import { all } from 'redux-saga/effects';
import authSagas from '@iso/redux/auth/saga';
import projectsSaga from '@iso/redux/projects/saga';
import referralsSaga from '@iso/redux/referrals/saga';
import groupsSaga from '@iso/redux/groups/saga';
import contractorsSaga from '@iso/redux/contractors/saga';
import networkContractorsSaga from '@iso/redux/networkContractors/saga';
import userCategoriesSaga from '@iso/redux/userCategories/saga';
import usersSaga from '@iso/redux/users/saga';
import profilesSaga from '@iso/redux/profiles/saga';
import projectitemsSaga from '@iso/redux/projectitems/saga';
import projectPaymentsSaga from '@iso/redux/projectPayments/saga';
import changeOrdersSaga from '@iso/redux/changeOrders/saga';
import projectWizardSaga from './projectWizard/saga';

export default function* rootSaga(getState) {
    yield all([
        authSagas(),
        projectsSaga(),
        referralsSaga(),
        groupsSaga(),
        contractorsSaga(),
        networkContractorsSaga(),
        userCategoriesSaga(),
        usersSaga(),
        profilesSaga(),
        projectitemsSaga(),
        projectPaymentsSaga(),
        changeOrdersSaga(),
        projectWizardSaga(),
    ]);
}
